import { render, staticRenderFns } from "./goodsNew.vue?vue&type=template&id=c62b2d5e&scoped=true&"
import script from "./goodsNew.vue?vue&type=script&lang=js&"
export * from "./goodsNew.vue?vue&type=script&lang=js&"
import style0 from "./goodsNew.vue?vue&type=style&index=0&id=c62b2d5e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62b2d5e",
  null
  
)

export default component.exports